export default "__VITE_ASSET__BgMx0fYc__"